import { DevBoxAddOn } from '../../models/add-ons';
import { createStringIdAdapter } from './common/string-id-adapter';

export const devBoxAddOnsAdapter = createStringIdAdapter<DevBoxAddOn[]>();
